import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import axios from '../../helpers/axios';
import { completeExternalLogin } from '../../actions/auth.action';
import { consumeVkIdFlow } from '../../services/vkIdClient';

export default function VkIdCallbackPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const started = useRef(false);
  const [step, setStep] = useState('loading');
  const [error, setError] = useState('');
  const [ticket, setTicket] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    (async () => {
      try {
        const params = new URLSearchParams(window.location.search);
        if (params.get('error')) throw new Error('Вы отменили авторизацию VK ID');
        const state = params.get('state');
        const flow = consumeVkIdFlow(state);
        const code = params.get('code');
        const deviceId = params.get('device_id');
        if (!code || !deviceId) throw new Error('VK не передал код авторизации или device_id');
        const { data } = await axios.post(flow.mode === 'link' ? '/auth/vk/link' : '/auth/vk/exchange',
          { code, deviceId, codeVerifier: flow.verifier, state });
        if (flow.mode === 'link') { navigate('/personalInformation', { replace: true }); return; }
        if (data.status === 'login') {
          dispatch(completeExternalLogin(data)); navigate('/personalInformation', { replace: true }); return;
        }
        if (data.status !== 'registration' || !data.ticket) throw new Error('Некорректный ответ ALOTB');
        setTicket(data.ticket); setFirstName(data.firstName || ''); setLastName(data.lastName || '');
        setEmail(data.suggestedEmail || ''); setStep('register');
      } catch (err) { setError(err?.response?.data?.message || err.message || 'Ошибка входа VK ID'); setStep('error'); }
    })();
  }, [dispatch, navigate]);

  const submit = async event => {
    event.preventDefault();
    if (busy) return;
    setBusy(true); setError('');
    try {
      if (step === 'register') {
        await axios.post('/auth/vk/register/start', { ticket, email, firstName, lastName });
        setStep('verify');
      } else if (step === 'verify') {
        const { data } = await axios.post('/auth/vk/register/confirm', { ticket, code });
        dispatch(completeExternalLogin(data)); navigate('/personalInformation', { replace: true });
      }
    } catch (err) { setError(err?.response?.data?.message || err.message || 'Ошибка регистрации'); }
    finally { setBusy(false); }
  };

  return <main style={{ minHeight: '65vh', padding: '48px 16px', display: 'flex', justifyContent: 'center' }}>
    <div style={{ width: '100%', maxWidth: 470, height: 'fit-content', padding: 26,
      border: '1px solid #596078', borderRadius: 14, background: '#161b29', color: '#fff' }}>
      <h2>Вход через VK ID</h2>
      {step === 'loading' && <p>Подтверждаем авторизацию…</p>}
      {step === 'error' && <p role="alert" style={{ color: '#ff9b9b' }}>{error}</p>}
      {step === 'register' && <form onSubmit={submit}>
        <p>Для регистрации ALOTB требуется подтверждённый email. Адрес VK не считается подтверждённым автоматически.</p>
        <label>Имя<input required minLength="3" maxLength="20" value={firstName} onChange={e => setFirstName(e.target.value)} style={field}/></label>
        <label>Фамилия<input required minLength="3" maxLength="20" value={lastName} onChange={e => setLastName(e.target.value)} style={field}/></label>
        <label>Email<input required type="email" autoComplete="email" value={email} onChange={e => setEmail(e.target.value)} style={field}/></label>
        <button disabled={busy} style={submitStyle}>Отправить код на email</button>
      </form>}
      {step === 'verify' && <form onSubmit={submit}>
        <p>Мы отправили шестизначный код на <strong>{email}</strong>. Код действует 5 минут.</p>
        <label>Код подтверждения<input required inputMode="numeric" maxLength="6" pattern="[0-9]{6}" value={code} onChange={e => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))} style={field}/></label>
        <button disabled={busy} style={submitStyle}>Подтвердить и зарегистрироваться</button>
        <button type="button" disabled={busy} onClick={() => setStep('register')} style={{ ...submitStyle, background: 'transparent' }}>Изменить email / отправить снова</button>
      </form>}
      {!!error && step !== 'error' && <p role="alert" style={{ color: '#ff9b9b' }}>{error}</p>}
      <p><a href="/" style={{ color: '#a6c8ff' }}>Вернуться на главную</a></p>
    </div>
  </main>;
}
const field = { boxSizing: 'border-box', display: 'block', width: '100%', padding: 12, margin: '8px 0 15px',
  borderRadius: 6, border: '1px solid #616979', background: '#262d3b', color: '#fff' };
const submitStyle = { width: '100%', marginTop: 12, padding: 13, borderRadius: 8, border: 0,
  background: '#0077ff', color: '#fff', cursor: 'pointer' };
